import { render, staticRenderFns } from "@/components/Layout/Menu/Reportes/Reporte_acarreo/Reporte_acarreo.html?vue&type=template&id=b1451392&scoped=true&"
import script from "@/components/Layout/Menu/Reportes/Reporte_acarreo/Reporte_acarreo.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Reportes/Reporte_acarreo/Reporte_acarreo.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Reportes/Reporte_acarreo/Reporte_acarreo.css?vue&type=style&index=0&id=b1451392&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1451392",
  null
  
)

export default component.exports